import startOfToday from 'date-fns/startOfToday';
import {calendarDaysAdapter, calendarWeeksAdapter} from './adapters';
import {CalendarState} from './types';

export const initialState: CalendarState = {
  days: calendarDaysAdapter.getInitialState(),
  weeks: calendarWeeksAdapter.getInitialState(),
  loadingStatus: 'NotLoaded',
  today: startOfToday().toISOString(),
};
